import { WixiPartner } from '@soluto-private/wixi-web-sdk';

export const wixiPartnerConfig: WixiPartner = {
  partnerSecret: 'dWUkL5rfMSTuMhC3',
  partnerAppId: 'dashboard-web',
  partnerId: 'asurion',
  partnerAppSecret: 'gg8MCRGW7TzC6SNk',
};
